import * as types from './type';

let user = localStorage.getItem('user');

const initialState = {
    customerProfile: '',
    customerError: '',
    customerSuccess: '',
    loggedIn: user && user != 'undefined' ? true : false
};



export default function customerReducer(state = initialState, action) {

  switch (action.type) {
      
    case types.GET_CUSTOMER_PROFILE: {
      if (action.payload && action.payload.data) {
        return {
          ...state,
          customerProfile: action.payload.data.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.LOGIN_REQUEST: {
      // console.log('inn')
      if (action.payload && action.payload.data) {
        return {
          ...state,
          customerAccessToken: action.payload.data.token
        }
      } else {
        return {
          ...state
        }
      }
    }
    
    
    case types.CHANGE_PASSWORD: {
      
      if (action.payload && action.payload.data) {
        return {
          ...state,
          customerSuccess: action.payload.data.message
        }
      } else {
        return { 
          ...state,
          customerError: action.payload.message.errors
        }
      }
    }
    case types.CUSTOMER_SIGNUP: {
      
      if (action.payload && action.payload.data) {
        return {
          ...state,
          customerSignUpSuccess: action.payload.data
        }
      } else {
        return { 
          
          ...state,
          customerError: action.payload.message.errors
        }
      }
    }
    case types.UPDATE_PROFILE: {
      
      if (action.payload && action.payload.data) {
        return {
          ...state,
          customerProfile: action.payload.data
        }
      } else {
        return {
          ...state
        }
      }
    }
    case types.LOGOUT:
            return {};
    default: {
      return {
        ...state
      };
    }
    
  }

}